import { useMemo } from 'react';
import useAuth from './useAuth';
import useRefreshToken from './useRefreshToken';
import { useLoading } from '../context/LoadingProvider';
import { useNotifications } from '../context/NotificationProvider';
import { createApiClient } from '../api/createApiClient';

export default function useApi() {
  const { auth, setAuth } = useAuth();
  const loader = useLoading();
  const notify = useNotifications();

  const api = useMemo(() => {
    return createApiClient({
      auth,
      loader,
      notify,
      setAuth
    });
  }, [auth, loader, notify]);

  return api;
}